import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RichTextEditorComponent } from './rich-text-editor.component';
import {LoadingIndicatorModule} from "../loading-indicator/loading-indicator.module";
import {EditorModule} from "primeng/editor";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        FormsModule,
        EditorModule,
        LoadingIndicatorModule,
        EditorModule
    ],
    declarations: [
        RichTextEditorComponent
    ],
    exports: [
        RichTextEditorComponent
    ]
})

export class RichTextEditorModule { }
